const routes = [
  {
    index: true,
    label: 'Magellan',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Research',
    path: '/research',
  },
  {
    label: 'Software',
    path: '/software',
  },
  {
    label: 'Data',
    path: '/data',
  },
  {
    label: 'Users',
    path: '/users',
  },
  {
    label: 'Lessons Learned',
    path: '/lessonslearned',
  },
];

export default routes;
